/** รำมาร (lane C4 skeleton): violet + blossom, motif moon. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const DEMONDANCE_FX: ReturnType<typeof makeHandArt> = makeHandArt('chorus', { a: 'violet', b: 'blossom', motif: 'moon' }, [
  ['dd-sleeve', 'palm', 2],
  ['dd-twirl', 'ring', 2.5],
  ['dd-petals', 'ring', 3],
  ['dd-drain', 'claw'],
  ['dd-mist', 'throw', 6],
  ['dd-trance', 'buff'],
  ['dd-dew', 'heal'],
  ['dd-heaven', 'power', 3.5],
]);
